import { useState } from "react";
import { authenticatedFetch } from '@/services/auth/authenticatedFetch.js';

export const useGetCompanyBenefitInvoice = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [data, setData] = useState(null);

    const getCompanyBenefitInvoice = async (companyBenefitInvoiceFileUuid) => {
        setLoading(true);
        setError(null);
        try {
            const response = await authenticatedFetch(window.ENV.BACKEND_URL+`/api/secured/users/companyBenefit/companyBenefitInvoiceFile/${companyBenefitInvoiceFileUuid}`, {
                method: "GET",
            });

            if (!response.ok) {
                throw new Error("Failed to retrieve company benefit invoice");
            }
            const blob = await response.blob();
            const url = URL.createObjectURL(blob);
            // console.log("blob file companyBenefit ", blob, url)

            setData({ url, type: blob.type });
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return { getCompanyBenefitInvoice, loading, error, data, refetch: getCompanyBenefitInvoice };
};
